import { BaseInfoCard, baseCardStyles } from "./base-info-card.js";

const template = document.createElement("template");

template.innerHTML = `
  <style>
    ${baseCardStyles}

    .icon-container {
      background-color: color-mix(in srgb, var(--p-purple-500, #a855f7) 12%, transparent);
      color: var(--p-purple-600, #9333ea);
    }

    :host-context(.app-dark) .icon-container,
    :host-context(.dark) .icon-container,
    :host-context(.p-dark) .icon-container,
    :host-context([data-theme="dark"]) .icon-container,
    :host-context([theme="dark"]) .icon-container,
    :host([theme="dark"]) .icon-container {
      background-color: color-mix(in srgb, var(--p-purple-400, #c084fc) 20%, transparent);
      color: var(--p-purple-400, #c084fc);
    }

    .card-value {
      color: var(--p-text-color, #334155);
    }

    :host-context(.app-dark) .card-value,
    :host-context(.dark) .card-value,
    :host-context(.p-dark) .card-value,
    :host-context([data-theme="dark"]) .card-value,
    :host-context([theme="dark"]) .card-value,
    :host([theme="dark"]) .card-value {
      color: var(--p-text-color, #ffffff);
    }

    .progress-bar {
      background-color: var(--p-purple-600, #9333ea);
    }

    :host-context(.app-dark) .progress-bar,
    :host-context(.dark) .progress-bar,
    :host-context(.p-dark) .progress-bar,
    :host-context([data-theme="dark"]) .progress-bar,
    :host-context([theme="dark"]) .progress-bar,
    :host([theme="dark"]) .progress-bar {
      background-color: var(--p-purple-400, #c084fc);
    }
  </style>

  <div class="info-card" id="card" data-route="/service/lite_schedule">
    <div class="card-top">
      <div class="icon-container">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
          <circle cx="12" cy="15" r="2"/>
        </svg>
      </div>
      <div class="card-body">
        <h3 class="card-title" id="title">משמרות משובצות</h3>
        <div class="card-value" id="value">0%</div>
        <p class="card-subtitle" id="subtitle">0 מתוך 0 שובצו</p>
      </div>
    </div>
    <div class="progress-container">
      <div class="progress-bar" id="progressBar" style="width: 0%"></div>
    </div>
  </div>
`;

class ShiftsScheduledCard extends BaseInfoCard {
  constructor() {
    super(template);
  }

  get defaultRoute() {
    return "/service/lite_schedule";
  }

  render() {
    const titleEl = this.shadowRoot.getElementById("title");
    const valueEl = this.shadowRoot.getElementById("value");
    const subtitleEl = this.shadowRoot.getElementById("subtitle");
    const progressBarEl = this.shadowRoot.getElementById("progressBar");

    if (!titleEl || !valueEl || !subtitleEl || !progressBarEl) return;

    const isHebrew = this.isHebrew;
    const services = this._data?.services || [];
    const shiftsService = services.find(s => s.serviceKey === "shifts" || s.serviceKey === "lite_schedule");
    const shiftsState = shiftsService?.state || {};
    const employeesList = shiftsState.employees || [];
    const totalStaff = employeesList.length;

    let assignedCount = 0;
    employeesList.forEach(emp => {
      if (emp.currentWeek?.assigned) assignedCount++;
    });

    const shiftsPct = totalStaff > 0 ? Math.round((assignedCount / totalStaff) * 100) : 0;

    titleEl.textContent = isHebrew ? "משמרות משובצות" : "Shifts Scheduled";
    valueEl.textContent = `${shiftsPct}%`;
    subtitleEl.textContent = isHebrew
      ? `${assignedCount} מתוך ${totalStaff} שובצו`
      : `${assignedCount} of ${totalStaff} assigned`;
    progressBarEl.style.width = `${Math.min(100, Math.max(0, shiftsPct))}%`;
  }
}

if (!customElements.get("shifts-scheduled-card")) {
  customElements.define("shifts-scheduled-card", ShiftsScheduledCard);
}

export { ShiftsScheduledCard };
